export const truncateString = (
    str: string,
    startLength: number = 5,
    endLength: number = startLength,
): string => `${str.slice(0, startLength)}...${str.slice(-endLength)}`;
